import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify';
import { useDMSContext } from '../../context/DMSContext';
import { useScreenWidth } from '../../hooks/useScreenWidth';
import dmsService from '../../services/DMSService';
import MyButton from '../../UI/button/MyButton';
import Card from '../../UI/Card/Card'
import MySelect from '../../UI/select/MySelect'
import MyToggle from '../../UI/switchButton/MyToggle';
import DobandaContainer from '../CalculatorWrappers/DobandaContainer';

const calcTypes = [
  { label: 'Penalitate', value:'PENALTIES'},
  { label: 'Inflație', value:'INFLATION'},
  { label: 'Imputația', value:'COMBINED'},
  { label: 'Dobânda de întârziere', value:'RATES'},
]
const ERROR_CLASS = 'error-input';

export default function SettingsSection() {
  const { settings, setSettings, refetchSettings } = useDMSContext();
  const [selectedRate, setSelectedRate] = useState(9);
  const interestRateRef = useRef(null);
  const isMobile = useScreenWidth(1043);

  useEffect(() => {
    setSelectedRate(settings.rateValue)
    if (interestRateRef.current && interestRateRef.current.classList) {
      interestRateRef.current.classList.remove(ERROR_CLASS);
    }
  }, [selectedRate,settings]);

  const resetSettings = async () =>{
    setSettings((prev)=>({
      ...prev,
      rateValue: 9,
      fromNextDay: false,
      calculationType: "PENALTIES",
      isCarantine:false
    }))
    const requestBody = {
      rateValue: 0.09,
      fromNextDay: false,
      calculationType: "PENALTIES",
      isCarantine:false
    }
    try {
      const response = await dmsService.updateSettings(requestBody);
      refetchSettings();
      toast.success("Setările au fost resetate")
    } catch (error) {
      toast.error("Eroare resetare setări")
    }
  }

  const validate = () =>{
    if (selectedRate === null) {
      toast.warning('Selectati rata dobanzii.', {
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return false;
    }
    if(settings.rateValue === '' && selectedRate === 'custom'){
      toast.warning('Introduceti rata dobanzii.', {
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      interestRateRef.current.classList.add(ERROR_CLASS);
      interestRateRef.current.focus();
        return false;
    }
    return true;
  }

  const updateSettings = async (e) => {
    e.preventDefault();

    if(!validate()){
      return;
    }

    let selectedRateValue;

    if (settings.rateValue && selectedRate === 'custom') {
      selectedRateValue = settings.rateValue / 100;
    } else {
      selectedRateValue = selectedRate / 100;
    }

    const requestBody = {
      fromNextDay: settings.fromNextDay,
      isCarantine: settings.isCarantine,
      calculationType: settings.calculationType,
      rateValue:parseFloat(selectedRateValue) 
    }

    try {
      const response = await dmsService.updateSettings(requestBody);
      refetchSettings();
      toast.success("Setările au fost actualizate cu succes");
    } catch (error) {
      toast.error("Eroare la actualizare setări")
    }

  }

  return (
    <div className='dms-content'>
       <div className='section-header'><h2>Setări Sistem</h2></div>
       <Card>
        <h3>Setări pentru calculul penalităților</h3>
        <form className='form-container' onSubmit={updateSettings}>
         <div className='toggles-row'>
         <div className='myInpWrapper'>
            <label htmlFor={"calcTypes"} className={'myInpLabel'}>Tip calcul</label>
              <MySelect 
                options={calcTypes}
                name="calcTypes"
                value={calcTypes.find(
                         option => option.value === settings.calculationType
                      )}
                 onChange={(selectedOption) => setSettings(prev =>({...prev, calculationType: selectedOption || ''}))}
                />
            </div>
          <DobandaContainer
            dobandaValue={settings.rateValue} 
            setDobandaValue={(newValue) => setSettings(prev => ({ ...prev, rateValue: newValue }))}
            selectedRate={selectedRate}
            setSelectedRate={setSelectedRate}
            required={true}
            interestRateRef = {interestRateRef}
          />
         </div>
         <div className='toggles-row'>
          <MyToggle
           name="nextDay"
           type="checkbox"
           label="Următoarea zi de la scadență"
           checked={settings.fromNextDay}
           onChange={(e) => setSettings(prev =>({...prev, fromNextDay: e.target.checked || ''}))}
          />
           <MyToggle
           name="isQuarantine"
           type="checkbox"
           label="Calculatorul nu va calcula perioada stărilor de urgență"
           checked={settings.isCarantine}
           onChange={(e) => setSettings(prev =>({...prev, isCarantine: e.target.checked || ''}))}
          />
          </div>
          <div className='inline-wrapper'>
          <MyButton
            style={{maxWidth:"245px",color:"var(--prolex-blue)",borderColor:"var(--prolex-blue)"}}
            id="saveSettingsBtn"
            body={<>Salvează</>}
            type='submit'
          />
          <MyButton
            style={{maxWidth:"245px",color:"var(--prolex-blue)",borderColor:"var(--prolex-blue)"}}
            id="resetSettingsBtn"
            body={<>Resetează</>}
            type='button'
            className='clear-button'
            onClick={resetSettings}
          />
          </div>
        </form>
      </Card>
    </div>
  )
}
